// inspired from https://github.com/ctrlplusb/react-universally
export const isBrowser = process.env.IS_BROWSER
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'
export const isProd = ['production', 'stage'].includes(process.env.NODE_ENV)
export const isServer = !process.env.IS_BROWSER
export const isBeta = process.env.NODE_ENV === 'beta'

export { ifElse } from './logic/ifElse'

export { styling } from './component/styling'

export { axios } from './ajax/axios'

/// minor utils

export { createCx } from './component/createCx'
export { getNaverLoginURL, getNaverLogoutURL, getNaverPopupLoginURL } from './naverLogin'
export { debounce } from './event/debounce'

export { StringUtils } from './stringUtils'
